import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

import CommentsMessages from '@/components/company-comments/CommentsMessages.vue';
    import CommentsInput from '@/components/company-comments/CommentsInput.vue';
    import type { Company, DashboardTableData } from '@/types';
    import {
        Dialog,
        DialogBody,
        DialogContent,
        DialogHeader,
        DialogTitle,
        DialogTrigger,
    } from '@/components/ui/dialog';
    import { Button } from '@/components/ui/button';
    import { computed, ref } from 'vue';
    import { useI18n } from 'vue-i18n';
    import Chat from '@/components/icons/Chat.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Comments',
  props: {
    company: {},
    commentCount: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const props = __props;

    const commentCountRef = ref<number>(props.commentCount);

    const commentCountFormatted = computed(() => {
        return commentCountRef.value > 9 ? '9+' : commentCountRef.value;
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), null, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogTrigger), { class: "relative flex cursor-pointer items-center justify-center" }, {
        default: _withCtx(() => [
          _createVNode(Chat, { className: "text-primary size-4 shrink-0" }),
          (commentCountRef.value > 0)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["bg-secondary absolute -top-1 -right-1 flex h-3 w-3 items-center justify-center rounded-full text-[8px] font-bold text-white", {
                    '-right-1.5 w-fit px-1': commentCountRef.value > 9,
                }])
              }, _toDisplayString(commentCountFormatted.value), 3))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_unref(DialogContent), { class: "sm:max-w-lg" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('dashboards.comment.title', { company: _ctx.company.name })), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(DialogBody), null, {
            default: _withCtx(() => [
              _createVNode(CommentsMessages, {
                "company-id": _ctx.company.id,
                "comment-count": commentCountRef.value
              }, null, 8, ["company-id", "comment-count"]),
              _createVNode(CommentsInput, {
                "company-id": _ctx.company.id,
                "status-id": _ctx.company.status_id,
                onCommentAdded: _cache[0] || (_cache[0] = ($event: any) => (commentCountRef.value++))
              }, null, 8, ["company-id", "status-id"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})